"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Region = exports.MAX_DRAWER_HEIGHT_PERCENT = void 0;
var Region;
exports.Region = Region;
(function (Region) {
  Region["Collapse"] = "collapse";
  Region["Expand"] = "expand";
})(Region || (exports.Region = Region = {}));
var MAX_DRAWER_HEIGHT_PERCENT = 1;
exports.MAX_DRAWER_HEIGHT_PERCENT = MAX_DRAWER_HEIGHT_PERCENT;